// ** Redux Imports
import { combineReducers } from "redux";

// ** Reducers Imports
import auth from "./auth";
import user from "./user";
import message from "./message";
import design from "./design";
import grille from "./grille";
import evaluation from "./evaluation";
import statistic from "./statistic";
import attribut from "./attribut";
import createGridAttribut from "./createGridAttribut";
import permissions from "./permission";
import calibrage from "./calibrage";

const rootReducer = combineReducers({
  auth,
  user,
  message,
  design,
  grille,
  evaluation,
  attribut,
  createGridAttribut,
  statistic,
  permissions,
  calibrage,
});

export default rootReducer;
